
import { Component, Vue } from 'vue-property-decorator';
import RealtimePage from './TwitterCrisisMonitor/RealtimePage.vue';
import { RouteConfig } from 'vue-router';
import SectionCard from '@/components/SectionCard.vue';
import HomeBannerTemplate from '@/components/HomeBannerTemplate.vue';
import { HomeSettingsBannerDTO } from '@/data/dto/homeSettings.dto';

@Component({
  components: {
    RealtimePage,
    SectionCard,
    HomeBannerTemplate,
  },
})
export default class HomeView extends Vue {
  private sections: RouteConfig[] = [];

  homeSettings = {} as HomeSettingsBannerDTO;

  get visibleSections(): RouteConfig[] {
    return this.sections.filter((section: RouteConfig) => {
      const meta = section.meta || {};
      const blocked = !meta.userAllowed || !!meta.blocked;
      const hiddenBlockedCard = !!meta.hiddenToNotAllowedUsers;
      const isActive = meta.active !== false;

      return isActive && ((!hiddenBlockedCard && blocked) || !blocked);
    });
  }

  getCardsData(): void {
    const userRoutes = this.$store.state.user.userRoutes;
    const routes =
      userRoutes.length > 0 ? userRoutes : this.$router.options.routes || [];

    this.sections = [];

    const excludedRoutes = [
      'login',
      'logout',
      'userNotAuthorized',
      'notFound',
      'home',
      'admin',
      'users',
      'groups',
    ];

    const filteredRoutes = routes.filter((route: RouteConfig) => {
      return !(route.name && excludedRoutes.includes(route.name as string));
    });

    this.sections.push(...filteredRoutes);
  }

  async getHomeBannerData(): Promise<HomeSettingsBannerDTO> {
    const response = await this.$store.dispatch('getHomeSettings');
    if (response) {
      this.homeSettings = response;
    }
    return response;
  }

  mounted(): void {
    this.getCardsData();
    this.getHomeBannerData();

    this.$watch(
      () => this.$store.state.user.userRoutes,
      () => {
        this.getCardsData();
      },
      { deep: true }
    );
  }
}
